import React from 'react'
// import { NavLink } from "react-router-dom";

import Colleges from '../../Colleges/Colleges';



const Admissionalert = () => {
    return (
        <div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col p-0 m-0">
                        <div className='background_banner blog_banner'>
                            <h2>Get Admission in Best colleges</h2>
                            <p>India is home to some of the finest educational institutions, renowned for their academic excellence, infrastructure, and placement opportunities</p>
                        </div>
                    </div>
                </div>
            </div>


            {/* 
            <div className="container mb-5">
                <div className="row pt-3 colegcontainer">
                    {college.map((item, index) => (
                        <div key={index} className="col-md-4 mt-3 college_col">
                            <div className="card h-100 ">
                                <img src={item.img} className="card-img-top" alt={item.link} />
                                <div className="card-body">
                                    <p className="college_rank text-dark fw-bold">{item.course}</p>
                                    <p className="college_description">{item.description}</p>
                                    <div className="pt-2">
                                        <NavLink className="fw-semibold card-link colcardlink mx-0 px-0 ">{item.link} <i className="fa fa-angle-double-right"></i></NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div> */}


            <Colleges />


        </div>
    )
}

export default Admissionalert
